import React, { useState } from 'react';
import { apiService } from '../../services/api';
import { useMutation } from '../../hooks/useApi';
import logger from '../../utils/logger';
import { Eye, FileDown } from 'lucide-react';

function RaportFitimiDetajuar() {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [shitjet, setShitjet] = useState({});
  const [totali, setTotali] = useState(null);
  const [error, setError] = useState('');

  const { mutate: fetchRaport, loading: loadingRaport } = useMutation(
    async ({ from, to }) => {
      return await apiService.get('/raport-fitimi-detajuar', { params: { from, to } });
    },
    {
      onSuccess: (data) => {
        setShitjet(data?.data || {});
        setTotali(data?.totali || null);
        setError('');
      },
      onError: () => {
        setError('Nuk mund të merret raporti me detaje.');
      },
      showNotifications: false
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    fetchRaport({ from, to });
  };

  const handleExportPdf = async () => {
    if (!from || !to) {
      setError('Ju lutem zgjidhni datat për PDF.');
      return;
    }
    try {
      const response = await apiService.get('/raport-fitimi-detajuar/pdf', {
        params: { from, to },
        responseType: 'blob'
      });
      const file = new Blob([response], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } catch (err) {
      logger.error('PDF export error:', err);
      setError('Dështoi shkarkimi i PDF-it.');
    }
  };
 

  return (
    <div className="space-y-6 animate-fade-in">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gradient-logo flex items-center gap-3 animate-slide-down">
        <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
          💰
        </div>
        Raporti i Fitimit me Detaje
      </h2>

      <form onSubmit={handleSubmit} className="card-premium p-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="form-label">Nga data</label>
          <input
            type="date"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
            className="input-premium"
            required
          />
        </div>
        <div>
          <label className="form-label">Deri më</label>
          <input
            type="date"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            className="input-premium"
            required
          />
        </div>
        <button
          type="submit"
          className="btn-primary mt-auto"
        >
          <Eye size={18} /> Shfaq
        </button>
      </form>

      {error && <p className="form-error text-center">{error}</p>}

      {loadingRaport && (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary-500 border-t-transparent"></div>
        </div>
      )}

      {Object.keys(shitjet).length > 0 && (
        <div className="space-y-10">
          <button
            onClick={handleExportPdf}
            className="btn-primary"
          >
            <FileDown size={18} /> Shkarko PDF
          </button>

          {Object.entries(shitjet).map(([lokacioni, rreshta], index) => {
            const shitjeTotale = rreshta.reduce((sum, s) => sum + Number(s.totali_shitje || 0), 0);
            const blerjeTotale = rreshta.reduce((sum, s) => sum + Number(s.totali_blerje || 0), 0);
            const fitimi = shitjeTotale - blerjeTotale;

            return (
              <div key={index} className="space-y-2">
                <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">Lokacioni: {lokacioni}</h3>

                {/* Desktop Table */}
                <div className="hidden md:block overflow-x-auto rounded-xl border border-gray-200 dark:border-dark-700 shadow">
                  <table className="table-premium">
                    <thead>
                      <tr>
                        <th className="p-3 text-left">Data</th>
                        <th className="p-3 text-left">Produkti</th>
                        <th className="p-3 text-left">Madhësia</th>
                        <th className="p-3 text-left">Ngjyra</th>
                        <th className="p-3 text-right">Sasia</th>
                        <th className="p-3 text-right">Blerje</th>
                        <th className="p-3 text-right">Shitje</th>
                        <th className="p-3 text-right">Fitimi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rreshta.map((s, i) => (
                        <tr key={i} className="border-t border-gray-200 dark:border-dark-700 hover:bg-gray-50 dark:hover:bg-dark-700/50">
                          <td className="p-3 text-gray-700 dark:text-gray-300">{s.data}</td>
                          <td className="p-3 font-medium text-gray-700 dark:text-gray-300">{s.produkti}</td>
                          <td className="p-3 text-gray-700 dark:text-gray-300">{s.madhesia}</td>
                          <td className="p-3 text-gray-700 dark:text-gray-300">{s.ngjyra}</td>
                          <td className="p-3 text-right text-primary-600 dark:text-primary-400 font-semibold">{s.sasia}</td>
                          <td className="p-3 text-right text-gray-700 dark:text-gray-300">{Number(s.cmimi_blerjes).toFixed(2)} Den</td>
                          <td className="p-3 text-right text-gray-700 dark:text-gray-300">{Number(s.cmimi_shitjes).toFixed(2)} Den</td>
                          <td className="p-3 text-right font-semibold text-green-600 dark:text-green-400">
                            {(Number(s.cmimi_shitjes) - Number(s.cmimi_blerjes)).toFixed(2)} Den
                          </td>
                        </tr>
                      ))}
                      <tr className="bg-gray-50 dark:bg-dark-700 font-semibold border-t border-gray-200 dark:border-dark-700">
                        <td colSpan="5" className="p-3 text-right text-gray-800 dark:text-gray-100">Totali:</td>
                        <td className="p-3 text-right text-gray-800 dark:text-gray-100">{blerjeTotale.toFixed(2)} Den</td>
                        <td className="p-3 text-right text-gray-800 dark:text-gray-100">{shitjeTotale.toFixed(2)} Den</td>
                        <td className="p-3 text-right text-green-600 dark:text-green-400">{fitimi.toFixed(2)} Den</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Mobile Cards */}
                <div className="md:hidden space-y-4">
                  {rreshta.map((s, i) => (
                    <div key={i} className="card-premium p-4 space-y-1">
                      <div><strong className="text-gray-700 dark:text-gray-300">Data:</strong> {s.data}</div>
                      <div><strong className="text-gray-700 dark:text-gray-300">Produkti:</strong> {s.produkti}</div>
                      <div><strong className="text-gray-700 dark:text-gray-300">Madhësia:</strong> {s.madhesia}</div>
                      <div><strong className="text-gray-700 dark:text-gray-300">Ngjyra:</strong> {s.ngjyra}</div>
                      <div><strong className="text-gray-700 dark:text-gray-300">Sasia:</strong> {s.sasia}</div>
                      <div><strong className="text-gray-700 dark:text-gray-300">Blerje:</strong> {Number(s.cmimi_blerjes).toFixed(2)} Den</div>
                      <div><strong className="text-gray-700 dark:text-gray-300">Shitje:</strong> {Number(s.cmimi_shitjes).toFixed(2)} Den</div>
                      <div className="font-semibold text-green-600 dark:text-green-400">
                        <strong>Fitimi:</strong> {(Number(s.cmimi_shitjes) - Number(s.cmimi_blerjes)).toFixed(2)} Den
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {!loadingRaport && Object.keys(shitjet).length === 0 && !error && (
        <div className="empty-state">
          <p className="empty-state-title">Asnjë e dhënë për t'u shfaqur</p>
          <p className="empty-state-description">Zgjidhni datat dhe klikoni "Shfaq" për të parë raportin.</p>
        </div>
      )}
    </div>
  );
}

export default RaportFitimiDetajuar;
